// extracted by mini-css-extract-plugin
export default {"productDownload":"ProductsDownload_productDownload__PPWYA","textPart":"ProductsDownload_textPart__KzP+o","imgPart":"ProductsDownload_imgPart__Gkl6v"};